var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 90,
    fill: "url(#pattern0_1354_20118)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_1354_20118",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1354_20118",
    transform: "scale(0.0111111)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1354_20118",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAAE60lEQVR4nO2dy4sdRRTGKwtfS4mIxiiIDOJCEhUVBaMhuvAPmPUsxO7+vuqOjKDjIpgHZBVJyEpHxK0rHziIuHWjbsIkavYu3BiTCMlCHZ3Rw3RkvOm+/bjdVV19zwcFl3trqqt+XffUqdOn7hijUqlUKpVKpVKpVCqVSqUyS0tLtwN4jeR3AK6T3BpjAXAdwLckD2dZdpvTW59l2V6S531DoHvo6zJ2ZzN5HiHz/7D7n9m5ufA+YPqFnfUOWmyy74HSf/mmd9AArg1goFueZ/S13kGXXdyMVPQ1XgVNBd2HdEY7koJ2JAXtSArakRS0IyloR1LQjqSgHUlBzyvoeStGQVNBcwAzUWc0/cNT00H/YNVGU0F7n3XUGU3voNR00D/EsdnoPwC8aa3dIwXAirwXSv1gQANYmWw7H1wQ9U0ooKMoureg7XtCqW9CAW2t3TPZtrzXVX2BNFlfYO6YwRdIfkhyGcCLxphdBcPdRfKQpMEBeB/AD8GBRsFXleRbXdWXzybrJ0nyMoDX0zR9sO345W9JpiYU0NxefFYaLla16wPYIHkUwP0mRHUIeqvvAmAty7KHTIjyDY/1yk/W2pdMyBoAxK2K8rm1drcJXQM3FW+XeA83SbL2ARwEcILkpyQvkrxC8s/c9svrH/PPjltrX3B6hmWggP8GwDr9B/CEuGokf2txnaskV621j88r6Feq+i1wSH7V4TW/JLnfB2iXsYjd4ieLCwfg5LT+Li8v3wHgLMm/erjBcv0zcoDKGWgfsQiSh6bZ5CRJHs53gH1/o9bjOF7oCPF/gxtMLGKaADwJ4Je+Ie8olwE8a7qSr9hF1AA0yad9HGqSa8Zx/JRz09Fl7AIF9aeYi19dQ95RLnViRnzFLrjt3x6JouiBioWvd5tcY2avz7xA+h4EyQ/K+pZ7F23blZv8hpgoKeLhVNz4KtinQwa9CeCRKX5yaxdOwDbxgmq0t5Gm6b5QQX89pV8zbUaaekE1YX8RKui4bFs9a9s9jXczSZLHggOdlcSW89jFEEFLeTco0AB+LuqPRNTaBIgcgr6yuLh4azCxDgAfFfVHQp1d3Mg+JxaA50OKdUQloE8EAPpYMFvwJEnuLgH9WQCgPwkGdBRFd5X052KTzYjpSE02NZIP0vgCvmIdtuQ5YJ24RtFmpCvV3NRcatywr1jHYsnKXWdGFX17ulJFttSNG/1744a7sFlsUaIoumWIoOM4vm9UoAHcOYPpqBVibaOKtLReTEevJS3Jl6u7GN4wU6Yj1TSP7RdDXz/HBuBgqO4dyY9D+oHBV0v6czwA0EfbgD7sCfRqUX8kgygA0Acag85TqdZdgwZwYUp/rg4Y9OVWQaV8cHs9wN4UV6oExurowqQTMymTH0R1tUCiJL8uf4w1RNCbvaaN+RC2c+FaQyly/epsRiomxpoZm0juz49TtIXS9IxMVXsb1tpHzRgF4MwMM7BprKaqnDJj1dL2z+Kfm9Ved1DOSzKPGbPiOF6Q2IIvyJJYGewBpaaSRENfSY6SxWrmSfCQtmutfcbMo+I4XnC0sTo3N+ai4j8gnZ7F9as4WvFOL0crQlWapvskFy7frXWRbLk2Wj+5C0kuHID38nOEje2wxC5Gt602PUoiahK+lOQWybuQpyD5YzHZpMjmRV5/L0F7qZMkyXOto3D/XvAfGhZ8AqwbJU0AAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendar-icon.d53f4618133f45a572a36c35bfdc4897.svg";
export { ForwardRef as ReactComponent };